import resizeImage from '@/helpers/imageResizeHelper'

export default {
    openMediaDialog: function(media, index) {
        if (media.type === 'photo') {
            let element = this.$refs[`media${index}`][0]
            element.click()
            return
        }

        this.openYoutubeDialog(media, index)
    },

    startImageCropping: function (event, photo, index) {
        const self = this

        self.errors[`media[${index}].path`] = null
        let input = event.target;
        if (input.files && input.files[0]) {
            let reader = new FileReader();
            reader.onload = async (e) => {
                photo.path = await resizeImage(e.target.result)
                self.openCropper(photo)
            };
            reader.readAsDataURL(input.files[0]);
        }
    },

    openCropper: function (photo) {
        const self = this

        self.showCropper = true
        self.croppingImage = photo
    },

    setPhoto: function(photo) {
        const self = this

        self.showCropper = false
        const { canvas } = self.$refs.photoCropper.getResult();
        photo.path = canvas.toDataURL('image/jpeg', 70)
    },

    openYoutubeDialog: function(media) {
        const self = this
        self.showVideoInput = true
        self.videoObj = media
    },

    setVideo: function(videoObj) {
        const self = this,
            url = videoObj.absolutePath ? videoObj.absolutePath : videoObj.path,
            regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
            match = url.match(regExp)

        let videoId = null

        if ( match && match[7].length === 11 ){
            videoId = match[7]
        }

        if (videoId) {
            self.videoError = null
            videoObj.path = `http://youtube.com/watch/?v=${videoId}`
            videoObj.absolutePath = `http://youtube.com/watch/?v=${videoId}`
            videoObj.preview = `http://i3.ytimg.com/vi/${videoId}/hqdefault.jpg`
            self.showVideoInput = false
            return
        }

        self.videoError = 'Não foi possível obter o video com o link informado'
    }
}
